import { useQuery } from '@tanstack/react-query'
import { getUserCharges } from '../utils/stripe-tools'

interface UseUserChargesParams {
  limit?: number
  startingAfter?: string
  enabled?: boolean
}

export const useUserCharges = (params: UseUserChargesParams = {}) => {
  const { limit = 10, startingAfter, enabled = true } = params

  return useQuery({
    queryKey: ['userCharges', { limit, startingAfter }],
    queryFn: () => getUserCharges({ limit, startingAfter }),
    enabled,
  })
}